module.exports = __webpack_public_path__ + "static/media/YandexMusicLogo.d0038e30.png";